/**
 * User preferences store using Zustand
 * Manages user-specific settings and preferences
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { UserPreferences } from '../types';

interface PreferencesState extends UserPreferences {
  // Actions
  updatePreferences: (updates: Partial<UserPreferences>) => void;
  reset: () => void;
}

// Default preferences
const DEFAULT_PREFERENCES: UserPreferences = {
  username: '',
  showNonSelectedTags: false,
  filterGrades: [],
  filterDocs: [],
  filterJurisdictions: [],
  filterStates: [],
  standardsSortField: 'grade',
  standardsSortDir: 'asc',
  standardsPreviewTab: 'metrics',
  standardsSortExpanded: false,
  metricsViewMode: 'all-alignments',
  standardsViewMode: 'aligned',
};

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      ...DEFAULT_PREFERENCES,

      updatePreferences: (updates) => {
        set((state) => ({
          ...state,
          ...updates,
          updatedAt: new Date(),
        }));
      },

      reset: () => {
        set(DEFAULT_PREFERENCES);
      },
    }),
    {
      name: 'user-preferences',
    }
  )
);
